/*
 *  -----------------------------------------------------------------------
 *    <copyright file="delete-excel-listing-config\index.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { useMutation } from '@apollo/client/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DialogActions } from '@mui/material';
import React from 'react';

import { useTranslation } from 'hooks';
import { DELETE_CUSTOM_REPORT, GET_REPORT_DEFINITIONS } from 'queries/report-definition';
import Button from 'views/components/core/buttons/button';
import { CustomDialog, DialogContent, DialogTitle } from 'views/components/core/dialog';

const DeleteCustomReportDialog = ({ open, onClose, reportId }: any) => {
    const { t } = useTranslation();
    const [deleteReport, { error, loading }] = useMutation(DELETE_CUSTOM_REPORT, {
        refetchQueries: [{ query: GET_REPORT_DEFINITIONS }],
    });

    return (
        <CustomDialog
            onClose={onClose}
            aria-labelledby="delete-custom-report"
            fullWidth
            maxWidth="md"
            scroll="paper"
            open={open}
            className="delete-custom-report-dialog"
        >
            <DialogTitle className="delete-custom-report-title">
                {t('admin:deleteExcelListingConfig')}
                <FontAwesomeIcon
                    icon={['fal', 'times']}
                    className="fa-lg close-icon-cv"
                    onClick={onClose}
                    data-testid="close-dialog"
                />
            </DialogTitle>

            <DialogContent className="dialog-content">
                <span className="confirm-text">{t('admin:confirmDeleteExcelListingConfig')}</span>
            </DialogContent>

            <DialogActions className="delete-cv-actions">
                <Button
                    className="delete-cv-btn"
                    id="cancel-delete-signatory"
                    text="cancel"
                    onClick={() => {
                        onClose();
                    }}
                />
                <Button
                    className="delete-cv-btn"
                    id="delete-signatory"
                    text="delete"
                    disabled={loading}
                    onClick={() => {
                        deleteReport({
                            variables: {
                                id: reportId,
                            },
                        }).then(onClose());
                    }}
                />
            </DialogActions>
        </CustomDialog>
    );
};

export default DeleteCustomReportDialog;
